<template>
  <div class="main user-layout-register">
    <h3>注册</h3>
    <a-form-model ref="registerForm" :model="form" :rules="rules" @submit.prevent="handleRegister">
      <a-form-model-item prop="phoneNumber">
        <a-input :maxLength="11" placeholder="请输入手机号码" v-model="form.phoneNumber"></a-input>
      </a-form-model-item>
      <a-form-model-item prop="verCode">
        <div class="verify_box">
          <!-- v-decorator="['verCode', { rules: [{ required: true, message: '请输入验证码' }], validateTrigger: 'blur' }]" -->
          <a-input v-model="form.verCode" placeholder="请输入验证码" :maxLength="6"></a-input>
          <div @click.stop.prevent="getCaptcha" class="verify_code">
            {{ state.send ? state.title : state.time + 's' }}
          </div>
        </div>
      </a-form-model-item>
      <a-form-model-item prop="nickName">
        <!-- v-decorator="['nickName', { rules: [{ required: true, message: '请输入验证码' }], validateTrigger: 'blur' }]" -->
        <a-input v-model="form.nickName" :maxLength="20" placeholder="请输入昵称"></a-input>
      </a-form-model-item>
      <a-form-model-item prop="password">
        <a-input ref="password" @blur="tip = false" @click="passInput" :type="!showPass ? 'password' : ''" placeholder="请输入密码" :maxLength="18" v-model="form.password">
          <a-tooltip :overlayClassName="'newPwdTooltips'" slot="suffix" v-model="tip" trigger="click">
            <!-- <a-icon type="info-circle" style="color: rgba(0,0,0,.45)" /> -->
            <template slot="title">
              <div>
                <div class="tips-item" :class="{ red: lenCheck }">
                  <SvgIcon style="width: 16px;height: 16px; margin-right: 8px;" :iconClass="!lenCheck ? 'pwdChecked' : 'pwdError'" />
                  <p>密码长度为6-18字符</p>
                </div>
                <div class="tips-item" :class="{ red: complexCheck }">
                  <SvgIcon style="width: 16px;height: 16px; margin-right: 8px;" :iconClass="!complexCheck ? 'pwdChecked' : 'pwdError'" />
                  <p>字母/数字以及标点符号至少包含2种</p>
                </div>
              </div>
            </template>
          </a-tooltip>
        </a-input>
        <SvgIcon class="iconStyle" :iconClass="!showPass ? 'hidePwd' : 'showPwd'" @click.stop="showPass = !showPass" />
      </a-form-model-item>
      <a-form-model-item prop="verPassword">
        <a-input :type="!showCheckPass ? 'password' : ''" @blur="checkTip = false" @click="checkPassInput" placeholder="请再次输入密码" :maxLength="18" v-model="form.verPassword">
          <a-tooltip :overlayClassName="'newPwdTooltips'" slot="suffix" v-model="checkTip" trigger="click">
            <!-- <a-icon type="info-circle" style="color: rgba(0,0,0,.45)" /> -->
            <template slot="title">
              <div>
                <div class="tips-item" :class="{ red: !checkPassValid.len }">
                  <SvgIcon style="width: 16px;height: 16px; margin-right: 8px;" :iconClass="checkPassValid.len ? 'pwdChecked' : 'pwdError'" />
                  <p>密码长度为6-18字符</p>
                </div>
                <div class="tips-item" :class="{ red: !checkPassValid.complex }">
                  <SvgIcon style="width: 16px;height: 16px; margin-right: 8px;" :iconClass="checkPassValid.complex ? 'pwdChecked' : 'pwdError'" />
                  <p>字母/数字以及标点符号至少包含2种</p>
                </div>
                <div class="tips-item" :class="{ red: !checkPassValid.same }">
                  <SvgIcon style="width: 16px;height: 16px; margin-right: 8px;" :iconClass="checkPassValid.same ? 'pwdChecked' : 'pwdError'" />
                  <p>两次输入密码一致</p>
                </div>
              </div>
            </template>
          </a-tooltip>
        </a-input>
        <SvgIcon style="width: 16px; height: 16px;" class="iconStyle" :iconClass="!showCheckPass ? 'hidePwd' : 'showPwd'" @click.stop="showCheckPass = !showCheckPass" />
      </a-form-model-item>
      <a-form-model-item :wrapperCol="{ span: 23 }">
        <div class="loginIsRegister">
          <span style="color: #84878D;cursor: pointer;">已有账号？</span>
          <span style="color:#4B7DFD;cursor: pointer;" @click="toLogin">去登录</span>
        </div>
      </a-form-model-item>
      <a-form-model-item>
        <div class="user-agreement">
          <p>登录或注册即代表同意乐私塾</p>
          <p style="color: #4B7DFD;cursor: pointer;" @click.stop="openLink('https://static.51lss.com/teamanager/agreement/lss_userAgreement.html')">
            《用户协议》
          </p>
          <p>和</p>
          <p style="color: #4B7DFD;cursor: pointer;" @click.stop="openLink('https://static.51lss.com/teamanager/agreement/lss_privacyAgreement.html')">
            《隐私协议》
          </p>
        </div>
        <a-button style="width: 370px;background: #4B7DFD;
border-radius: 6px;" size="large" type="primary" html-type="submit" :loading="loading">注册</a-button>
        <!-- <a-checkbox size="small" style="color: #AEB5C5;" :checked="checked" @change="checked = !checked"
          v-model="form.checkbox">
          <span>阅读并接受</span>
          <a style="color:#1564FF;" @click.prevent.stop="$router.push({ name: 'user' })">《乐私塾用户协议》</a>
        </a-checkbox> -->
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon'
// import md5 from 'md5'
import { sendRegisterPhoneCode, existMobile } from '@/api/system'
import { resign } from '@/api/user'
import { mapActions } from 'vuex'
import { passReg, nameReg } from '@/utils/regs'
import Vue from 'vue'
export default {
  name: 'Register',
  components: { SvgIcon },
  data() {
    return {
      showCheckPass: false,
      showPass: false,
      passReg,
      checked: false,
      loading: false,
      tip: false,
      checkTip: false,
      state: {
        title: '获取验证码',
        time: 60,
        send: true
      },
      form: {
        phoneNumber: '',
        verCode: '',
        nickName: '',
        password: '',
        verPassword: '',
        checkbox: false
      },
      rules: {
        phoneNumber: [
          { required: true, message: '请输入手机号码', trigger: 'none' },
          { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式不正确', trigger: 'none' }
        ],
        verCode: [{ required: true, message: '请输入验证码', trigger: 'none' }],
        nickName: [
          { required: true, message: '昵称不能为空', trigger: 'none' },
          { pattern: nameReg, message: '昵称只能是汉字、大小写字母、数字和标点符号', trigger: 'none' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'none' },
          { pattern: passReg, message: '密码设置格式不符合', trigger: 'none' }
        ],
        verPassword: [
          { validator: this.confirmPassword, trigger: 'none' },
          { pattern: passReg, message: '密码设置格式不符合', trigger: 'none' },
          { validator: this.compPwd, trigger: 'none' }
        ],
        checkbox: [
          { required: true, message: '请阅读并同意乐私塾用户协议', trigger: 'none' },
          { validator: this.validatorCheckbox }
        ]
      },
      checkPassValid: {
        len: false,
        complex: false,
        same: false
      }
    }
  },
  watch: {
    'form.password'(val) {
      this.checkPassValid.same = this.form.password === this.form.verPassword
    },
    'form.verPassword'(val) {
      if (!val.trim()) {
        this.checkPassValid.len = false
        this.checkPassValid.complex = false
        this.checkPassValid.same = false
        return
      }
      const reg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)/
      if (val.trim().length > 5 && val.trim().length < 19) {
        this.checkPassValid.len = true
      } else {
        this.checkPassValid.len = false
      }
      this.checkPassValid.complex = reg.test(val.trim())
      this.checkPassValid.same = this.form.password === this.form.verPassword
    }
  },
  computed: {
    lenCheck() {
      if (this.form.password.trim().length > 5 && this.form.password.trim().length < 19) {
        return false
      } else {
        return true
      }
    },
    complexCheck() {
      const reg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)/
      if (!this.form.password.trim()) {
        return true
      }
      return !reg.test(this.form.password.trim())
    }
    // sameCheck() {
    //   if (!this.form.password || !this.form.verPassword) {
    //     return true
    //   }
    //   return !(this.form.password === this.form.verPassword)
    // }
    // passwordLevelClass() {
    //   return levelClass[this.state.passwordLevel]
    // },
    // passwordLevelName() {
    //   return levelNames[this.state.passwordLevel]
    // },
    // passwordLevelColor() {
    //   return levelColor[this.state.passwordLevel]
    // }
  },
  methods: {
    ...mapActions(['loginAsync']),
    openLink(link) {
      window.open(link)
    },
    passInput() {
      !this.tip && (this.tip = true)
    },
    checkPassInput() {
      !this.checkTip && (this.checkTip = true)
    },
    toLogin() {
      this.$router.back()
    },
    confirmPassword(rule, value, callback) {
      if (value === undefined || !value) {
        callback(new Error('请输入密码'))
      }
      callback()
    },
    compPwd(rule, value, callback) {
      const password = this.form.password
      if (value && password && value.trim() !== password.trim()) {
        callback(new Error('两次密码不一致'))
      }
      callback()
    },
    validatorCheckbox(rlue, value, callback) {
      if (!value) {
        callback(new Error('请阅读并同意乐私塾用户协议'))
      }
      callback()
    },
    async login(params) {
      try {
        const res = await this.loginAsync({
          ...params,
          grant_type: 'stu_password'
        })
        // // res && this.$message.success('登录成功')
        res && this.$router.push({ name: 'study', query: { ocode: Vue.ls.get('code') } })
        this.loading = false
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    handleRegister(e) {
      this.$refs.registerForm.validate(async vaild => {
        try {
          if (vaild) {
            this.loading = true
            // console.log(this.form)
            // const { phoneNumber, password } = this.form
            console.log(this.form, 'this.form')
            const res = await resign({ ...this.form, ocode: this.$ls.get('code') || '' })
            if (res) {
              this.$message.success('注册成功')
              this.$router.push({ path: '/user/login', replace: true })
              // this.login({
              //   username: phoneNumber,
              //   password: password
              // })
            }
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      })
      // this.registerForm.validateFields(async (error, values) => {
      //   if (error) {
      //     console.log(error)
      //     return
      //   }
      //   try {
      //     this.loading = true
      //     const { phoneNumber, password } = values
      //     const res = await resign(values)
      //     if (res) {
      //       this.$message.success('注册成功')
      //       this.login({
      //         phoneNumber,
      //         password: md5(password + process.env.VUE_APP_SALT)
      //       })
      //     }
      //   } catch (error) {
      //     console.log(error)
      //   } finally {
      //     this.loading = false
      //   }
      // })
    },
    getCaptcha() {
      const phoneNumber = this.form.phoneNumber
      this.$refs.registerForm.validateField('phoneNumber', async msg => {
        if (msg || !this.state.send) return
        try {
          const isExist = await existMobile({
            orgCode: this.$ls.get('code') || '',
            mobile: phoneNumber
          })
          if (isExist) {
            this.$message.error('你已注册账号，无需重复注册')
            return
          }
          const res = await sendRegisterPhoneCode({ ocode: this.$ls.get('code') || '', phoneNumber: phoneNumber })
          console.log(res)
          this.state.send = false
          this.timer = setInterval(() => {
            if (this.state.time-- <= 0) {
              this.state.title = '重新发送'
              this.state.time = 60
              this.state.send = true
              clearInterval(this.timer)
            }
          }, 1000)
        } catch (error) {
          console.log(error)
        }
      })
      // if (!phoneNumber) {
      //   this.$message.error('请先输入手机号')
      //   return
      // }
      // if (!this.state.send) {
      //   return
      // }
      // try {
      //   const res = await featchCode({ phoneNumber })
      //   console.log(res)
      //   this.state.send = false
      //   this.timer = setInterval(() => {
      //     if (this.state.time-- <= 0) {
      //       this.state.title = '重新发送'
      //       this.state.time = 60
      //       this.state.send = true
      //       clearInterval(this.timer)
      //     }
      //   }, 1000)
      // } catch (error) {
      //   console.log(error)
      // }
    }
  }
}
</script>
<style lang="less">
.newPwdTooltips {
  .ant-tooltip-arrow {
    &::before {
      background-color: #fff !important;
    }
  }

  .ant-tooltip-inner {
    background-color: #fff;
    color: #303133;

    .tips-item {
      font-size: 14px;
      display: flex;
      align-items: center;

      &.red {
        color: #ef463a;
      }
    }
  }
}
</style>
<style lang="less" scoped>
@import './index.less';

.user-layout-register {
  .ant-form-item {
    display: flex;
    width: 100%;
    margin-bottom: 19px;

    &.ant-form-item-with-help {
      margin-bottom: 0;
    }

    .input-box {
      display: flex;
      align-items: center;
    }

    /deep/ .ant-form-item-label {
      line-height: 48px;
    }

    // align-items: center;
    /deep/ .ant-form-item-control-wrapper {
      padding-left: 10px;

      .ant-form-item-control {
        height: 100%;

        .ant-form-explain {
          font-size: 12px;
          line-height: 22px;
          padding: 0;
        }
      }

      .iconStyle {
        width: 16px;
        height: 16px;
        position: absolute;
        right: 10px;
        top: 0px;
      }

      input {
        box-sizing: border-box;
        width: 370px;
        height: 48px;
        background: #f5f8fa;
        border-radius: 6px;
        padding-right: 30px;
        font-size: 14px;

        // &::-webkit-input-placeholder {
        //   font-size: 14px;
        // }
      }
    }
  }

  .loginIsRegister {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .user-agreement {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #9ea1a5;
    margin-bottom: 10px;
  }
}

.red {
  color: #f55;
}

// .ant-form-item-with-help {
//   margin-bottom: 0;
// }
// /deep/.ant-card {
//   margin: 12px 0;
// }
// /deep/.ant-form-explain {
//   padding: 5px 0;
//   line-height: 24px;
// }
.verify_box {
  position: relative;

  .verify_code {
    position: absolute;
    top: 0;
    right: 0;
    width: auto;
    line-height: 45px;
    padding: 0 18px;
    cursor: pointer;
    background: none;
    border: none;
    color: #1564ff;
  }
}
</style>
